import React, { useState } from "react";
import { MdAdd } from "react-icons/md";
import { RiSubtractLine } from "react-icons/ri";

function CompositionAdd({ onAdd }) {
  const [isVisible, setIsVisible] = useState(false); // Initially hidden
  const [elements, setElements] = useState([{ inputValue: "", selectedElement: "Select Element" }]);

  const handleInputChange = (index, event) => {
    const { name, value } = event.target;
    const newElements = [...elements];
    newElements[index][name] = value;

    setElements(newElements);
    // Call the parent's function to update immediately
    onAdd(newElements.filter(element => element.inputValue && element.selectedElement !== "Select Element"));
  };

  const handleAddField = (event) => {
    event.preventDefault(); // Prevent form submission
    setElements([...elements, { inputValue: "", selectedElement: "Select Element" }]);
    setIsVisible(true); // Show input section on button click
  };

  const handleRemoveField = (index) => {
    const newElements = elements.filter((_, i) => i !== index);
    setElements(newElements);
    // Call the parent's function to update immediately
    onAdd(newElements.filter(element => element.inputValue && element.selectedElement !== "Select Element"));
  };

  return (
    <>
      <h1 className="title mt-4">Composition</h1>

      <div
        className="search"
        style={{
          backgroundColor: "#f4f4f4",
          border: "none",
          borderTop:"2px solid #004aad",
          padding: "10px",
        }}
      >
        <button
          type="button" // Prevents form submission
          onClick={handleAddField}
          style={{
            marginBottom: "15px",
            backgroundColor: "#004aad",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            padding: "8px 12px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            fontSize: "17px",
          }}
        >
          <MdAdd style={{ marginRight: "5px" }} /> Add
        </button>
            {isVisible && elements.map((element, index) => (
              <div
                key={index}
                className="row mb-3"
              >
                <div className="col-md-5">
                  <select
                    name="selectedElement"
                    value={element.selectedElement}
                    onChange={(e) => handleInputChange(index, e)}
                    className="form-select"
                  >
                    <option value="Select Element">Select Element</option>
                    <option value="Option 2">Option 2</option>
                    <option value="Option 3">Option 3</option>
                  </select>
                </div>
                <div className="col-md-5">
                  <input
                    type="text"
                    name="inputValue"
                    className="form-control"
                    value={element.inputValue}
                    onChange={(e) => handleInputChange(index, e)}
                    placeholder="e.g. 95%, <1%, Trace"
                    onFocus={(e) => (e.currentTarget.style.borderColor = "black")} // Change border color on focus
                    onBlur={(e) => (e.currentTarget.style.borderColor = "#ccc")} // Reset border color on blur
                  />
                </div>
      
                
                {/* <br /> */}
                <div className="col-md-2">
                  <button onClick={() => handleRemoveField(index)} className="btn btn-danger">
                    <RiSubtractLine />
                  </button>
                </div>
              </div>
            ))}
          </div>
    </>
  );
}

export default CompositionAdd;
